import { render } from "./Stars.vue?vue&type=template&id=5265b30b&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import "./Stars.vue?vue&type=style&index=0&id=5265b30b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5265b30b"

export default script